import React, { useContext, useState } from "react";
import { ConfirmDialog, IconButton, useNotifications } from "sprint-common-web";

import { useDeliveryBucketsApi } from "../../api/useDeliveryBucketsApi";
import { DeliveryBucketListingContext } from "../../context/DeliveryBucketListingContext";

interface EnableDeliveryBucketButtonProps {
    itemId: string;
}

export const EnableDeliveryBucketButton: React.VFC<EnableDeliveryBucketButtonProps> = ({
    itemId
}: EnableDeliveryBucketButtonProps) => {
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

    const { enableDeliveryBucket } = useDeliveryBucketsApi();
    const { success } = useNotifications();
    const { enableDeliveryBucketItem } = useContext(DeliveryBucketListingContext);

    const openDialog = () => {
        setIsDialogOpen(true);
    };

    const closeDialog = () => {
        setIsDialogOpen(false);
    };

    const handleEnable = async () => {
        await enableDeliveryBucket({ deliveryBucketId: itemId });
        success("Bucket succesfully enabled");
        enableDeliveryBucketItem(itemId);
        closeDialog();
    };

    return (
        <>
            <IconButton
                key={itemId}
                iconProps={{ iconName: "CheckboxComposite" }}
                tooltipContent="Enable"
                onClick={openDialog}
            />
            <ConfirmDialog
                title="Enable delivery bucket"
                text="Are you sure you want to enable this delivery bucket?"
                hidden={!isDialogOpen}
                confirm={{ onClick: handleEnable }}
                cancel={{ onClick: closeDialog }}
            />
        </>
    );
};
